<template>
  <v-app id="inspire">
    <v-navigation-drawer
        app
        permanent
        :mini-variant="!drawer"
        v-model="drawer"
        :class="{mini: !drawer}"
    >
      <v-app-bar absolute color="secondary" dark>
        <v-toolbar-title v-if="drawer"><v-img height="30" src="@/assets/images/IFPI-logo-Whiteblack.svg"></v-img></v-toolbar-title>
        <v-spacer v-show="drawer"></v-spacer>
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"/>
      </v-app-bar>

      <v-layout start column fill-height>
        <v-app-bar dark></v-app-bar>
        <UserProfileItem/>
        <v-layout justify-space-between column fill-height>
          <MainMenu/>
          <v-container class="ma-0 pa-0">
            <LangaugeSwitcher v-show="false"/>
            <AppVersion v-show="false"/>
          </v-container>
        </v-layout>
      </v-layout>
    </v-navigation-drawer>

    <v-app-bar app color="secondary" dark style="padding-right: 20px;">
      <v-toolbar-title class="display-1">{{ pageTitle }}</v-toolbar-title>
      <v-spacer/>

      <v-row style="max-width: 20em; margin-right: 10px; margin-top: 12px;" v-if="authenticated">
        <v-select
            :placeholder="$t('rightsholders.placeholder')"
            :items="rightholdersList"
            @change="onChangeRightsholder"
            :value="$store.getters['app/currentRightsholder'].id"
            class="t-rh-select"
          />
      </v-row>

      <v-menu bottom left>
        <template v-slot:activator="{on, attrs}">
          <v-btn icon v-on="on" v-bind="attrs" class="t-lang-switcher">
            <flag :iso="currentFlag"/>
          </v-btn>
        </template>

        <v-list>
          <v-list-item v-for="item in languages" :key="item.value" @click="switchLocale(item.lang)">
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-btn icon @click="notificationsViewed = true" class="t-notifications-btn" v-if="authenticated && currentRightsholderId">
        <v-badge
            color="primary"
            :value="$store.getters['app/unreadNotificationsCount'] > 0"
            :content="String($store.getters['app/unreadNotificationsCount'])"
        >
          <v-icon>mdi-bell-outline</v-icon>
        </v-badge>
      </v-btn>
    </v-app-bar>

    <v-dialog
        :value="forcePickRHDisplayed"
        max-width="30%"
        persistent
    >
      <v-card>
        <v-card-title>{{$t('common.forcePicker.title') }}</v-card-title>
        <v-card-subtitle>{{$t('common.forcePicker.subtitle') }}</v-card-subtitle>

        <v-card-text>
          <v-select
              :placeholder="$t('common.forcePicker.placeholder')"
              :items="rightholdersList"
              :value="$store.getters['app/currentRightsholder']"
              @change="onChangeRightsholder"
              class="t-select-rightsholder"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-navigation-drawer
        v-model="notificationsViewed"
        fixed
        right
        temporary
        width="400px"
    >
      <NotificationsPanel></NotificationsPanel>
    </v-navigation-drawer>

    <v-main>
      <v-container class="fullwidth-top ma-0 pa-0" fluid>
        <slot></slot>
        <GeneralNotificationForms></GeneralNotificationForms>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import MainMenu from "@/components/common/MainMenu";
import LangaugeSwitcher from "@/components/LangaugeSwitcher";
import AppVersion from "@/components/AppVersion";
import UserProfileItem from "@/components/UserProfileItem";
import NotificationsPanel from '@/components/common/notifications/NotificationsPanel';
import {mapActions, mapGetters} from "vuex";
import GeneralNotificationForms from '@/components/common/notifications/GeneralNotificationForms';

export default {
  data: () => ({
    drawer: true,
    notificationsViewed: false,
    alertDialog: false
  }),

  components: {
    MainMenu,
    LangaugeSwitcher,
    AppVersion,
    UserProfileItem,
    NotificationsPanel,
    GeneralNotificationForms,
  },

  methods: {
    ...mapActions('app', ['switchLocale']),

    onChangeRightsholder(itemId) {
      this.$store.dispatch('app/resetCurrentRightsholder', itemId);
    }
  },

  computed: {
    ...mapGetters('app', ['currentRightsholder']),

    forcePickRHDisplayed() {
      return this.$store.getters['app/currentRightsholder'].id === null && this.rightholdersList.length > 0
    },
    rightholdersList() {
      if (!this.$store.getters["app/rightsholders"].list) {
        return [];
      }
      return this.$store.getters["app/rightsholders"].list.map(item => ({value: item.id, text: item.name}));
    },

    authenticated() {
      return this.$store.getters["app/isAuthenticated"];
    },

    currentFlag() {
      return this.languages.find(({lang}) => lang === this.language).flag;
    },

    language() {
      return this.$store.getters["app/locale"];
    },
    languages() {
      return [
        {text: this.$t('common.languages.en'), flag: "GB", lang: 'en'},
        {text: this.$t('common.languages.sv'), flag: "SE", lang: 'sv'},
      ];
    },

    pageTitle() {
      return this.$t(this.$route.meta.title) || this.$t('app.name');
    },

    currentRightsholderId() {
      return this.currentRightsholder.id;
    }

  },

  mounted() {

    // setTimeout(async () => {
    //   const rhs = this.$store.getters["app/rightsholders"].list;
    //   for (let rh of rhs) {
    //
    //     // eslint-disable-next-line no-await-in-loop
    //     const result = await API.actions.Staging.getList(rh.id);
    //
    //     if (result.data.count >= 0) {
    //       console.log(rh.id + ' \t ' + rh.name  + ' \t ' + result.data.count);
    //     }
    //   }
    // }, 3000);

  }
};
</script>

<style lang="scss">
.v-navigation-drawer.mini {
  .v-toolbar__content {
    justify-content: center;
    padding: 0;

    .v-btn.v-btn--icon.v-app-bar__nav-icon {
      margin-right: 0;
    }
  }
}
</style>